<template>
  <section class="mb-5">
    <h2 class="display-4 mb-4">Service des Geräts Bearbeiten</h2>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <form method="post" enctype="multipart/form-data" class="container">
            <div class="mb-3">
              <label for="header" class="form-label">Titel</label>
              <input type="text" class="form-control" v-model="header" id="header">
            </div>
            <div class="mb-3">
              <label for="bodytext" class="form-label">Beschreibung</label>
              <textarea class="form-control" id="bodytext" v-model="bodytext" rows="5"></textarea>
            </div>
            <div class="mb-3">
              <label for="formFile" class="form-label">Bild</label>
              <input class="form-control" type="file" @change="handleFiles" id="formFile" />
            </div>
            <div v-if="thumbnail" class="col-8 mb-3">
              <img :src="$store.state.config.endpoint + thumbnail" alt="" class="img-thumbnail">
            </div>
            <button type="button" class="btn btn-primary" @click="addOrEditService">Speichern</button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServicePopup",

  data() {
    return {
      uid: null,
      file: '',
      header: '',
      bodytext: '',
      thumbnail: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.modules.api
        .viewPopupThumbnail()
        .then((resp) => {
          if (resp.status == 200) {
            this.uid = resp.data.result[0].uid
            this.thumbnail = resp.data.result[0].thumbnail
            this.header = resp.data.result[0].header
            this.bodytext = resp.data.result[0].bodytext
          } else {

          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  },

  watch: {},

  methods: {
    handleFiles(event) {
      if (event.target.files[0].size < 10000000) {
        this.file = event.target.files[0]
      }
    },
    addOrEditService() {
      event.preventDefault();
      let data = {
        uid: this.uid,
        file: this.file,
        header: this.header,
        bodytext: this.bodytext
      }

      this.$store.state.modules.api
        .addPopupThumbnail(data)
        .then((resp) => {
          console.log(resp)
          if (resp.status == 200) {

            this.uid = resp.data.result.uid
            this.thumbnail = resp.data.result.thumbnail
            this.header = resp.data.result.header
            this.bodytext = resp.data.result.bodytext

            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Neues Gerät",
                message: "Das Gerät wurde erfolgreich hinzugefügt",
              },
              2500
            );
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
};
</script>
